export var Base = 'base';
export var Exception = 'exception';
//# sourceMappingURL=issues.js.map